import { registerComponent, debounce } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "bulk-search",
  class BulkSearch extends WYATTElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.input = this.querySelector('[name="q"]');
      this.templateView = "bulk";
      this.resetButton = this.querySelector('button[type="reset"]');
      this.queryPerformed = false;
      this.inputChange = debounce(this.onInputChange.bind(this), 300);

      if (this.form) {
        this.form.addEventListener("reset", this.onFormReset.bind(this));
        this.form.addEventListener("submit", this.onFormSubmit.bind(this));
      }
      if (this.input) {
        this.input.addEventListener("input", this.inputChange);
      }

      this.subscribe(
        WYATT.PubSub.events.paginateTo,
        this.onPaginate.bind(this),
      );
    }

    disconnectedCallback() {
      super.disconnectedCallback();
    }

    onInputChange(event) {
      const { value } = event.target;
      if (value === "" && this.queryPerformed) {
        this.publish(WYATT.PubSub.events.bulkSearch, null);
      }
      this.toggleResetButton();
    }

    async onPaginate(event) {
      const { url } = event.detail;
      if (url) {
        if (!url.searchParams.has("view")) {
          url.searchParams.set("view", this.templateView);
        }
        const childNodes = await this.querySearch(url);
        this.publish(WYATT.PubSub.events.bulkSearch, childNodes);
        this.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    toggleResetButton() {
      if (this.resetButton) {
        const resetVisible = this.resetButton.checkVisibility();

        if (this.input.value.length === 0 && resetVisible) {
          this.resetButton.classList.add("hidden");
        } else if (this.input.value.length > 0 && !resetVisible) {
          this.resetButton.classList.remove("hidden");
        }
      }
    }

    async onFormSubmit(event) {
      event.preventDefault();
      const formData = new FormData(event.target);
      const { q: query } = Object.fromEntries(formData.entries());
      if (query) {
        const url = `/search?q=${query}&view=${this.templateView}`;
        const childNodes = await this.querySearch(url);
        this.publish(WYATT.PubSub.events.bulkSearch, childNodes);
        this.queryPerformed = true;
      } else {
        this.publish(WYATT.PubSub.events.bulkSearch, null);
        this.queryPerformed = false;
      }
    }

    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();

      this.publish(WYATT.PubSub.events.bulkSearch, null);
    }

    async querySearch(url) {
      try {
        const response = await fetch(url);
        const htmlString = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const nodes = doc.body.children;
        return nodes;
      } catch (error) {
        window.console.error(error);
        return null;
      }
    }
  },
);
